interface BayWindowsProps {
  city: string;
}

export function BayWindows({ city }: BayWindowsProps) {
  const bayTypes = [
    {
      icon: 'ri-arrow-left-right-line',
      title: 'Baie Vitrée Coulissante',
      description: 'Réparation de rails, roulettes, joints et mécanismes de verrouillage. Compatible avec toutes marques.',
      brands: 'Technal, K-Line, Schüco'
    },
    {
      icon: 'ri-layout-line',
      title: 'Baie à Galandage',
      description: 'Intervention sur systèmes escamotables, réparation de rails encastrés et mécanismes de coulissement.',
      brands: 'Reynaers, Kawneer, Technal'
    },
    {
      icon: 'ri-stack-line',
      title: 'Baie Vitrée Pliante',
      description: 'Réparation de charnières, ajustement des vantaux, remplacement de joints et systèmes d\'ouverture accordéon.',
      brands: 'Solarlux, Schüco, K-Line'
    },
    {
      icon: 'ri-stop-line',
      title: 'Baie Vitrée Fixe',
      description: 'Remplacement de vitrage, réparation de joints d\'étanchéité, traitement de l\'isolation thermique.',
      brands: 'Toutes marques'
    },
    {
      icon: 'ri-arrow-up-down-line',
      title: 'Baie Oscillo-Battante',
      description: 'Réparation de ferrures, ajustement des mécanismes d\'ouverture, remplacement de poignées et serrures.',
      brands: 'Veka, Rehau, Schüco'
    },
    {
      icon: 'ri-drag-move-line',
      title: 'Baie Levante-Coulissante',
      description: 'Réparation de systèmes de levage, ajustement de rails, remplacement de roulettes et joints.',
      brands: 'Technal, Reynaers, K-Line'
    }
  ];

  const interventions = [
    {
      icon: 'ri-settings-3-line',
      title: 'Remplacement de Roulettes et Rails',
      description: 'Changement de roulettes usées, réparation ou remplacement de rails endommagés pour un coulissement fluide.'
    },
    {
      icon: 'ri-window-2-line',
      title: 'Remplacement de Vitrage',
      description: 'Installation de double ou triple vitrage, réparation de vitres cassées ou fissurées, amélioration de l\'isolation.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Changement de Joints d\'Étanchéité',
      description: 'Remplacement de joints usés pour éliminer les infiltrations d\'eau et d\'air, amélioration de l\'isolation.'
    },
    {
      icon: 'ri-tools-line',
      title: 'Réglage et Ajustement',
      description: 'Ajustement précis des vantaux, réglage de la hauteur et de l\'alignement pour une fermeture parfaite.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Réparation de Serrures et Poignées',
      description: 'Remplacement de poignées cassées, réparation de serrures multipoints, amélioration de la sécurité.'
    },
    {
      icon: 'ri-temp-cold-line',
      title: 'Amélioration de l\'Isolation',
      description: 'Optimisation de l\'isolation thermique et phonique, traitement des ponts thermiques, réduction des déperditions.'
    }
  ];

  return (
    <section id="baies-vitrees" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Réparation de Baies Vitrées à {city}
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Spécialiste de la réparation de baies vitrées toutes marques. 
            Intervention rapide sur tous types de baies vitrées et tous systèmes d'ouverture.
          </p>
        </div>

        <div className="mb-16">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Types de Baies Vitrées</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {bayTypes.map((type, index) => (
              <div key={index} className="bg-white p-6 rounded-xl hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${type.icon} text-2xl text-teal-600`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{type.title}</h4>
                <p className="text-sm text-gray-600 mb-3 leading-relaxed">{type.description}</p>
                <p className="text-xs text-teal-600 font-medium">
                  <strong>Marques :</strong> {type.brands}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Nos Interventions</h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {interventions.map((intervention, index) => (
              <div key={index} className="bg-white p-6 rounded-xl hover:shadow-lg transition-shadow">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center mb-4">
                  <i className={`${intervention.icon} text-2xl text-emerald-600`}></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-2">{intervention.title}</h4>
                <p className="text-sm text-gray-600 leading-relaxed">{intervention.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-gray-700 mb-6">
            <strong>Marques compatibles :</strong> Technal, K-Line, Schüco, Reynaers, Kawneer, Veka, Rehau, Solarlux et toutes autres marques
          </p>
          <a 
            href="#contact" 
            className="inline-block bg-teal-600 text-white px-8 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Demander un Devis Gratuit
          </a>
        </div>
      </div>
    </section>
  );
}